import { constants } from '@nhl/formatter-utilities';

import actionCreators from './actionCreators';
import gameDataAPI, { getNumberOfEventsByDate } from 'media-base-ui/utils/gameDataAPI';

const setNumberOfEventsByDate = actionCreators.setNumberOfEventsByDate;

export const fetchGameDateData = (startDate, endDate, teams, selectedFilters) => async dispatch => {
    dispatch(actionCreators.requestGameDateData());

    try {
        // TODO: Use fetchGameData, or use cached fetchGameData from gameList.
        const data = await gameDataAPI.fetchCalendarData({
            startDate: startDate.format(constants.DATE_FORMAT),
            endDate: endDate.format(constants.DATE_FORMAT)
        });

        const events = getNumberOfEventsByDate(data.data, teams, selectedFilters, true);

        dispatch(actionCreators.setNumberOfEventsByDate(events));
        dispatch(actionCreators.gameDateDataResponse(true, data.data, null));
    } catch (error) {
        dispatch(actionCreators.gameDateDataResponse(false, [], error))
    }
};

export default {
    fetchGameDateData,
    setNumberOfEventsByDate
}
